import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { DatasetApi } from '../api/DatasetApi';

const KEYS = {
    datasets: ['dataset'],
    images: ( id: number ) => ['dataset', id.toString(), 'image']
};

export function useDatasets() {
    return useQuery( { queryKey: KEYS.datasets, queryFn: DatasetApi.getDatasets } );
}

export function useCreateDataset() {
    const qc = useQueryClient();
    return useMutation( {
        mutationFn: DatasetApi.createDataset,
        onSuccess: () => { qc.invalidateQueries( { queryKey: KEYS.datasets } ); }
    } );
}

export function useUploadImage( datasetId: number ) {
    const qc = useQueryClient();
    return useMutation( {
        mutationFn: ( files: File[] ) => DatasetApi.uploadImage( datasetId, files ),
        onSuccess: () => { qc.invalidateQueries( { queryKey: KEYS.images( datasetId ) } ); }
    } );
}
